import cloneDeep from 'lodash/cloneDeep';
import type { BoardState, GridPosition } from '../../../game/boardMVC/types';

export function applyHorizontalSymmetry(originalBoard: BoardState): BoardState {
  const symmetricalBoard = cloneDeep(originalBoard);

  // force odd number of columns
  if (symmetricalBoard.cols % 2 === 0) {
    symmetricalBoard.cols += 1;
  }

  const { cols } = symmetricalBoard;
  const midX = Math.round(cols / 2);

  const getReflectedEntries = <T extends GridPosition>(collection: T[]): T[] => {
    const output: T[] = [];
    collection.forEach((stack) => {
      if (stack.x > midX - 1) {
        return;
      }

      if (stack.x === midX - 1) {
        output.push({
          ...stack,
        });
        return;
      }

      output.push(
        {
          ...stack,
        },
        {
          ...stack,
          x: cols - 1 - stack.x,
        },
      );
    });
    return output;
  };

  return {
    ...symmetricalBoard,
    stacks: getReflectedEntries(symmetricalBoard.stacks),
    hiddenStacks: getReflectedEntries(symmetricalBoard.hiddenStacks),
    blockers: getReflectedEntries(symmetricalBoard.blockers ?? []),
  };
}
